import * as React from 'react';
import { observer } from 'src/utils/mobx-react';
import { SvgIcon, SvgIconPropsType } from 'src/ui/assets/icons/utils';

export const NetBallIcon = observer('NetBallIcon', ({ className, onClick }: SvgIconPropsType): JSX.Element => {
    return (
        <SvgIcon
            width='24'
            height='24'
            viewBox='0 0 50 50'
            fill='#061A32'
            xmlns='http://www.w3.org/2000/svg'
            className={className}
            onClick={onClick}
        >
            <path
                d='M35.34,23.71H14.7c-.23,0-.38.19-.38.38v1.9c0,.23.15.38.38.38h20.6c.23,0,.38-.15.38-.38v-1.9c.04-.19-.15-.38-.34-.38Z'
                fill='fill'
            />
            <path
                d='M32.67,29.42l-.27.27-1.52-1.52.99-.99h-1.07l-.46.46-.46-.46h-1.07l.99.99-1.52,1.52-1.52-1.52.99-.99h-1.07l-.46.46-.46-.46h-1.07l.99.99-1.37,1.37c-.34-.99-.72-1.75-1.03-2.36h-.88c1.22,2.13,2.28,5.41,2.48,9.44,0,.19.19.38.38.38h0c.19,0,.38-.19.38-.38-.04-1.03-.15-2.02-.3-2.89l.88-.88,1.52,1.52c-1.64,1.64-1.07,1.07-1.18,1.18-.15.15-.15.38,0,.53s.38.15.53,0l1.18-1.18,1.29,1.29c.15.15.38.15.53,0s.15-.38,0-.53l-1.29-1.29,1.52-1.52,1.22,1.22c-.11.8-.19,1.64-.23,2.51,0,.19.15.38.38.38h0c.19,0,.38-.15.38-.38.23-4.91,1.64-8.03,2.48-9.44h-.88c-.34.57-.69,1.33-1.03,2.28ZM25.17,32.77c-.08-.42-.15-.84-.27-1.22l.76.76-.5.46ZM24.64,30.22l1.52-1.52,1.52,1.52-1.52,1.52-1.52-1.52ZM28.25,33.84l-1.52-1.52,1.52-1.52,1.56,1.56c-.53.46-1.03.95-1.56,1.49ZM28.79,30.22l1.52-1.52,1.52,1.52c-.5.53-1.03,1.03-1.52,1.52l-1.52-1.52ZM31.72,33.12l-.84-.84,1.29-1.29c-.19.65-.34,1.37-.46,2.13Z'
                fill='fill'
            />
            <path
                d='M25.78,16.59c.8.42,1.6.5,1.94.5.34-.57,1.52-2.17,3.69-2.48-.38-.46-.8-.84-1.33-1.1-2.21.53-3.58,2.02-4.3,3.08Z'
                fill='fill'
            />
            <path
                d='M28.25,19.79c-.04-.91-.38-1.64-.53-1.94-.69-.04-2.7-.23-4.04-2.06-.23.53-.34,1.07-.34,1.68,1.6,1.87,3.73,2.25,4.91,2.32Z'
                fill='fill'
            />
            <path
                d='M30.23,21.43c.76-2.25.15-4.19-.46-5.37-.76.5-1.22,1.14-1.41,1.45.34.61,1.14,2.48.23,4.53.61-.08,1.14-.3,1.64-.61Z'
                fill='fill'
            />
            <path
                d='M25.13,16.21c.61-.91,1.83-2.36,3.81-3.08-1.94-.46-3.81.38-4.84,1.94.27.46.65.84,1.03,1.14Z'
                fill='fill'
            />
            <path
                d='M27.72,22.07c.3-.53.46-1.03.5-1.52-1.1-.08-3.08-.42-4.72-1.87.5,1.9,2.21,3.31,4.23,3.39Z'
                fill='fill'
            />
            <path
                d='M31.22,20.63c1.37-1.49,1.6-3.62.69-5.29-.53.04-1.03.15-1.45.34.5,1.03,1.14,2.86.76,4.95Z'
                fill='fill'
            />
        </SvgIcon>
    );
});
